import { observable, observe } from "mobx";
import { RuntimeRepository } from "core/repository";
import BaseService from "core/service/base.service";

class BasePresenter {
  static router = null;

  constructor(props) {
    this._props = props;
    this.subscriptions = [];
    this.watches = [];
    this._earlyStart();
  }

  watch(property, callback) {
    this.watches.push(
      observe(this.props[property], change => callback(change.object))
    );
  }

  initialState() {
    return {};
  }

  async _earlyStart() {
    this.mRuntime = await RuntimeRepository.getInstance();
    this.mCancelToken = BaseService.getNewCancelToken();
    this.onStart();
  }

  async onStart() {
    // TO BE OVERRIDEN
  }

  async onEnd() {
    this.subscriptions.forEach(({ event, subscriptionId }) =>
      this.mRuntime.unsubscribe(event, subscriptionId)
    );
    this.watches.forEach(disposer => disposer());
    if (this.mCancelToken) {
      this.mCancelToken.cancel();
    }
  }

  renewCancelToken() {
    if (this.mCancelToken) {
      this.mCancelToken.cancel();
    }
    this.mCancelToken = BaseService.getNewCancelToken();
  }

  controlApiRequests() {
    return true;
  }

  get props() {
    return this._props.get();
  }

  get router() {
    return BasePresenter.router;
  }

  get route() {
    return this.router.stateService.current;
  }

  get routeParams() {
    return this.router.stateService.params;
  }

  get viewModel() {
    if (this._viewModel) {
      return this._viewModel;
    }

    this._viewModel = observable(this.initialState());
    return this._viewModel;
  }

  navigateTo(state, params = {}, options = {}) {
    this.router.stateService.go(state, params, options);
  }

  subscribeTo(event, callback) {
    const subscriptionId = this.mRuntime.subscribe(event, callback);
    this.subscriptions.push({ event, subscriptionId });
  }

  sendNotification(options) {
    this.mRuntime.fire(RuntimeRepository.props.notification, options);
  }
}

export default BasePresenter;



// WEBPACK FOOTER //
// ./src/core/presenter/base.presenter.js